module.exports = __webpack_public_path__ + "static/og-image-ee-e657a300803e4392da0fb995fa35c27b.png";